import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { CohortResetEligibilityDto } from './cohort-reset-eligibility.dto';

@Injectable()
export class CohortResetService {
  constructor(
    private http: HttpClient,
    private oeAppService: OeAppService,
    private oeAppPersonService: OeAppPersonService
  ) {}

  getResetEligibility$(): Observable<CohortResetEligibilityDto> {
    const personId = this.oeAppPersonService.id;
    return this.http.get<CohortResetEligibilityDto>(
      `${this.oeAppService.oeProfileServiceHost}/v1/persons/${personId}/cohort-reset-eligibility`
    );
  }

  resetCohort$(): Observable<void> {
    const personId = this.oeAppPersonService.id;
    return this.http.post<void>(
      `${this.oeAppService.oeProfileServiceHost}/v1/persons/${personId}/cohort-reset`,
      {}
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/cohort/cohort-reset.service.ts